import { changeImageUrl } from '../../utils/index'
import { PicPathEnum } from '../../enum'
import { jsonRequest } from '../../utils/request'
import { PathEnum } from '../../enum/pathEnum'
export default {
  name: 'compaign',
  data() {
    return {
      picList: [],
      videoList: [],
      muted: true
    }
  },

  watch: {
    $route(to) {
      if (to.params && to.params.type) {
        this.initHandle(to.params.type)
      }
    }
  },
  created() {
    const { params } = this.$route
    if (params && params.type) {
      this.initHandle(params.type)
    }
  },
  methods: {
    changeImageUrl,
    async initHandle(type) {
      const { data } = await jsonRequest(PathEnum.COMPAIGN)
      if (data[type]) {
        this.getPicList(data[type])
      } else {
        this.$router.push('/')
      }
    },

    getPicList(data) {
      const { picEnd, dirPath, picType } = data
      const picArray = Array(picEnd)
        .fill()
        .map((_, i) => {
          i++
          return changeImageUrl(PicPathEnum.COMMON_URL + dirPath + '/' + i + picType)
        })
      if (picType.indexOf('.mp4') > -1) {
        this.videoList = picArray
      } else {
        this.picList = picArray
      }
    }
  }
}
